// eslint-disable-next-line no-restricted-imports
import TextField, { TextFieldProps } from '@mui/material/TextField';

import { CSSObject, styled } from '../styled';

import { InputStyleProps } from './types';

export const StyledInput = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'helperTextAbsolute' && prop !== 'mode',
})<TextFieldProps & InputStyleProps>(
  ({ theme, helperTextAbsolute, mode = 'standard', multiline, disabled }) => ({
    'label, label.Mui-focused, label.Mui-error, .input-label': {
      color: disabled
        ? theme.palette.inputLabelDisabled
        : theme.palette.inputLabel,
      ...theme.typography.caption,
      transform: 'none',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: 'inherit',
      position: 'relative',
    },

    '& input, & textarea': {
      ...theme.typography.bodyMedium,

      '&:-webkit-autofill': {
        transition: 'background-color 5000s ease-in-out 0s',
        boxShadow: 'none',
      },
      '&::placeholder': {
        ...theme.typography.bodyMedium,
        color: theme.palette.inputPlaceholder,
        opacity: 1,
      },
    },

    '& .MuiInputBase-root': {
      ...(multiline ? { minHeight: 52 } : { height: 52 }),
      textWrap: 'nowrap',
      whiteSpace: 'nowrap',
      border: `1px solid ${theme.palette.inputBorder}`,
      borderRadius: 8,
      paddingLeft: 12,
      paddingRight: 12,
      '&::before': {
        content: 'none',
      },
      '&.Mui-error': {
        '&::before': {
          content: 'none',
        },
        borderColor: theme.palette.inputBorderError,
      },
      '&:hover:not(.Mui-disabled, .Mui-error)': {
        borderColor: theme.palette.inputBorderHover,
      },
      '&.Mui-focused:not(.Mui-disabled, .Mui-error)': {
        borderColor: theme.palette.inputBorderFocused,
      },
      '&:after': {
        content: 'none',
      },
    },
    'label+.MuiInputBase-root': {
      marginTop: 4,
    },
    '.MuiFormHelperText-root': {
      fontSize: 12,
      ...(helperTextAbsolute && {
        position: 'absolute',
        bottom: -22,
      }),
    },

    ...(mode === 'filled' &&
      ({
        background: theme.palette.inputFilledBg,
        borderRadius: 40,
        paddingLeft: 16,
        paddingRight: 16,
        border: `1px solid var(--Gray-150, ${theme.palette.inputFilledBorder});`,

        '.MuiInputBase-root:after, .MuiInputBase-root:before': {
          content: 'none',
        } as CSSObject,
      } as CSSObject)),

    ...(mode === 'compact' &&
      ({
        background: theme.palette.inputCompactBg,
        borderRadius: 8,
        paddingLeft: 16,
        paddingRight: 16,
        border: `1px solid var(--Gray-150, ${theme.palette.inputCompactBorder});`,

        '& .MuiInputBase-root': {
          height: 32,
        },
        '.MuiInputBase-root:after, .MuiInputBase-root:before': {
          content: 'none',
        } as CSSObject,
      } as CSSObject)),

    '&': {
      '.input-copy': {
        display: 'none',
      } as CSSObject,

      '&:hover .input-copy': {
        display: 'inline-flex',
      },
    },
    '& .MuiInputAdornment-root': {
      position: 'static',
      display: 'flex',
      transform: 'none',
      alignItems: 'center',
      gap: 4,
    },
  })
);
